<div class="idd-training-certificates-edit" *ngIf="iddTrainingCertificateObject" fxLayout="column" fxLayoutGap="15px" >

  <div class="status-info">
    <mat-form-field appearance="fill" [ngClass]="'input-color-' + iddTrainingCertificateObject.status.color">
      <mat-label>Status</mat-label>
      <input matInput placeholder="Status" [disabled]="true" [value]="iddTrainingCertificateObject.status?.name">
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutGap="15px">
    <button (click)="save()" mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button  (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>

  </div>
  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px">

    <div fxLayout="column" [fxFlex]="'100'" fxFlex.lt-md="100" fxLayoutGap="15px">

      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Zaświadczenie</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <app-detail fxFlex="100" header="Rok" [value]="iddTrainingCertificateObject.iddTraining.year"></app-detail>
              </div>
              <div fxFlex="50">
                <app-detail fxFlex="100" header="Ofwca" [value]="iddTrainingCertificateObject.iddTraining.ofwca.fullName"></app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <app-dict-insurance-companies fxFlex="100" label="TU" [required]="true" [control]="insuranceCompanyControl"
                                              [hideChildren]="true"
                ></app-dict-insurance-companies>              </div>
              <div fxFlex="50">
                <app-datepicker
                  label="Data szkolenia"
                  placeholder="2000-01-01 00:00"
                  [required]="true"
                  [control]="realisedAtControl"
                ></app-datepicker>              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="33">
                <app-time-input
                  label=" Majątek"
                  [required]="false"
                  [control]="realisedAssetsMinutesControl"
                ></app-time-input>
            </div>

              <div fxFlex="33">
                <app-time-input
                  label=" Życie"
                  [required]="false"
                  [control]="realisedLifeMinutesControl"
                ></app-time-input>
              </div>

              <div fxFlex="3">
                <app-time-input
                  label=" Ogólne"
                  [required]="false"
                  [control]="realisedGeneralMinutesControl"
                ></app-time-input>
           </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <mat-form-field fxFlex="100">
                  <mat-label>Temat</mat-label>
                  <input matInput placeholder="Temat" [formControl]="trainingTopicControl" [required]="true">
                  <mat-error *ngIf="trainingTopicControl.hasError('required')">To pole jest wymagane</mat-error>

                </mat-form-field>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <mat-slide-toggle color="accent" [formControl]="amlControl">AML</mat-slide-toggle>
              </div>
            </div>
          </mat-card>
        </div>
      </div>

      <img
        class="certificate-overview"
        alt="Zaświadczenie"
        [src]="'/rest/crm/idd-training-certificate/' + iddTrainingCertificateObject.uuid + '/image'"
      />
    </div>

  </div>


</div>
